var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { cloneElement, useMemo, useRef } from 'react';
import clsx from 'clsx';
import { DEFAULT_GET_OPTION_VALUE, DropdownTestIds } from '../../dropdown.constants';
import { getVirtualizedOptionHeight } from '../../util';
var displayName = 'DropdownList';
export function DropdownList(props) {
    var _a;
    var _b, _c;
    // props
    var id = props.id, children = props.children, classes = props.classes, compact = props.compact, computedRecentSelected = props.computedRecentSelected, focused = props.focused, _d = props.getOptionValue, getOptionValue = _d === void 0 ? DEFAULT_GET_OPTION_VALUE : _d, groupBy = props.groupBy, options = props.options, optionsByGroup = props.optionsByGroup, selectedOptionsIds = props.selectedOptionsIds, showRecentlySelected = props.showRecentlySelected, virtualize = props.virtualize, virtualizeProps = props.virtualizeProps;
    // local variables
    var isGroupingEnabled = Boolean(groupBy);
    // styles
    var dropdownClassName = clsx((_a = {},
        _a[(_b = classes === null || classes === void 0 ? void 0 : classes.dropdownListVirtualized) !== null && _b !== void 0 ? _b : ''] = virtualize,
        _a[(_c = classes === null || classes === void 0 ? void 0 : classes.dropdownList) !== null && _c !== void 0 ? _c : ''] = !virtualize,
        _a));
    var getOptionValueRef = useRef(getOptionValue);
    getOptionValueRef.current = getOptionValue;
    // memos
    var computedOptions = useMemo(function () {
        return isGroupingEnabled
            ? Object.entries(optionsByGroup !== null && optionsByGroup !== void 0 ? optionsByGroup : []).flatMap(function (optionGroup) {
                return __spreadArray([optionGroup[0]], __read(optionGroup[1]), false);
            })
            : showRecentlySelected && selectedOptionsIds.size
                ? options.filter(function (option) { var _a; return !computedRecentSelected.lookup.has((_a = getOptionValueRef.current) === null || _a === void 0 ? void 0 : _a.call(getOptionValueRef, option)); })
                : options;
    }, [
        computedRecentSelected.lookup,
        isGroupingEnabled,
        options,
        optionsByGroup,
        selectedOptionsIds.size,
        showRecentlySelected,
    ]);
    var virtualizedHeight = useMemo(function () {
        return virtualize
            ? Math.min(400, computedOptions.reduce(function (prev, opt) { return prev + getVirtualizedOptionHeight(opt, __assign(__assign({}, virtualizeProps), { compact: compact })); }, 0))
            : undefined;
    }, [compact, computedOptions, virtualize, virtualizeProps]);
    return (_jsx("div", __assign({ "aria-expanded": focused, className: dropdownClassName, "data-hawkins-style": "dropdownList", "data-testid": DropdownTestIds.CONTAINER, id: id, role: "listbox", style: { height: virtualizedHeight }, tabIndex: -1 }, { children: children && cloneElement(children, { options: computedOptions }) })));
}
DropdownList.displayName = displayName;
